module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/$.is-object.js
// module id = ./node_modules/core-js/library/modules/$.is-object.js
// module chunks = 11056403903869698000